import {useAccount} from "../../../administration/users/AccountProvider";
import {useUserManager} from "../../technical/auth/UserManagerContext";
import React, {useEffect, useMemo} from "react";
import { Alert } from '@mui/material';
import Button from "@mui/material/Button";
import {drawerRoutes, routeVisibleForUser} from "../router/routes";
import {useTranslation} from "react-i18next";
import {formatUser} from "../../../administration/users/User";
import {useNavigate} from "react-router";

export function NoAccountServiceAccessPage() {
  const account = useAccount();
  const navigate = useNavigate();
  const userManager = useUserManager();
  const {t} = useTranslation();

  const visibleRoutes = useMemo(() => drawerRoutes.filter(routeVisibleForUser(account)), [account]);

  useEffect(() => {
    if (visibleRoutes.length > 0) {
      // If user goes to a route which he has no access to, he gets forwarded to his first route
      console.info('Forwarding user to page ' + visibleRoutes[0].path);
      navigate(visibleRoutes[0].path);
    }
  }, [visibleRoutes, navigate]);

  if (visibleRoutes.length > 0) {
    return <></>
  }
  return (
    <>
      <Alert color={'error'}>{t('PersonalData.noAccessToAccountServiceMsg', {userName: formatUser(account)})}</Alert>
      <Button variant={'contained'} fullWidth={false} style={{width: 'fit-content'}} onClick={() => userManager.signoutRedirect({
        post_logout_redirect_uri: `${window.location.href}`
      }).then()}>Logout</Button>
    </>
  )
}
